import { Component, Input } from '@angular/core';
import { Career } from '../../../../interfaces/career';
import { IconService } from '../../../../services/icon.service';

@Component({
  selector: 'app-portal-career-promoted-item',
  templateUrl: './portal-career-promoted-item.component.html',
  styleUrls: ['./portal-career-promoted-item.component.scss']
})
export class PortalCareerPromotedItem {
  constructor(private iconService: IconService){}
  @Input({ required: true }) career!: Career;

  ngOnInit(): void{
    this.iconService.addIconToRegistry({
      key: this.career.icon,
      path: this.career.icon
    });
  }
}
